import { render } from "./ResetPasswordForm.vue?vue&type=template&id=2b13f862"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"
script.render = render

export default script